import { useEffect, useRef } from "react";

const SCRIPT_SRC = "https://api.autodrivecrm.com/js/form_embed.js";
const IFRAME_SRC = "https://api.autodrivecrm.com/widget/booking/CZruSKcrhs8BBCB2bCrf";

/**
 * Embeds the GoHighLevel (AutoDrive CRM) booking widget.
 * Loads the embed script once per page so the iframe auto-resizes.
 */
export const BookingCalendar = ({ className = "", minHeight = 720 }: { className?: string; minHeight?: number }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof document === "undefined") return;
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.type = "text/javascript";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div ref={containerRef} className={className}>
      <iframe
        src={IFRAME_SRC}
        title="Schedule a free consultation"
        style={{ width: "100%", border: "none", overflow: "hidden", minHeight }}
        scrolling="no"
        id="byHzGg8JDmpdAtAUnv8m_booking"
      />
    </div>
  );
};

export default BookingCalendar;
